import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            ct: number
            queries: {
                [query: string]: {
                    ct: number
                    wt: number
                }
            }
        }
    }
}

export default class Shopware6ShopwareShouldUseElasticsearch extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        if (message) {
            const { args } = message

            return (
                <div>
                    <p>
                        We found the following <strong>{message.args.ct} product listing aggregation queries</strong> performed with SQL
                        that take a significant amount of time:
                    </p>
                    <ul>
                        {Object.entries(args.queries).map(([call, stats]) => (
                            <li key={call}>
                                {call} <Milliseconds value={stats.wt} />.
                            </li>
                        ))}
                    </ul>
                    <p>
                        You should consider Elasticsearch/OpenSearch with Shopware to reduce these load times on the category and search
                        pages. See the{' '}
                        <a href="https://developer.shopware.com/docs/guides/hosting/infrastructure/elasticsearch/elasticsearch-setup.html">
                            Shopware documentation
                        </a>{' '}
                        on how to get started with Elasticsearch.
                    </p>
                </div>
            )
        }
    }
}
